







import { Component, Vue } from 'vue-property-decorator';
import { reportIndexPvUvAndTimeCost } from '@tencent/ppd-base-libs';
import sdk from '@/business/sdk';

@Component
export default class App extends Vue {
  private created() {
    reportIndexPvUvAndTimeCost();
    sdk.disableCopyUrl();
    return;
  }
}
